import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bonusomat-odometer" }
const _hoisted_2 = {
  key: 1,
  class: "bonusomat-odometer__unit"
}

import { computed, onMounted, ref, watch } from "vue";
import Odometer from "odometer";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-counter',
  props: {
    counterValue: {},
    numeralCount: {},
    unit: {},
    isWidget: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const odometerDigitsRefs = ref<HTMLDivElement[]>([]);

// Parses number to array of each numeral, e.g. number "250731" when using numeralCount = 7 => [0, 2, 5, 0, 7, 3, 1]
const parseNumberToNumeralArray = (val: number): number[] => {
    const numeralArray: number[] = [];
    let currentVal = val;

    for (let i = props.numeralCount - 1; i >= 0; i--) {
        const power = Math.pow(10, i);
        if (currentVal >= power) {
            numeralArray.push(Math.floor(currentVal / power));
            currentVal = currentVal % power;
        } else {
            numeralArray.push(0);
        }
    }

    return numeralArray;
};

const odometerDigitsValues = computed(() => parseNumberToNumeralArray(props.counterValue));

watch(odometerDigitsValues, (newValue) => {
    for (let i = 0; i < odometerDigitsValues.value.length; i++) {
        odometerDigitsRefs.value[i].innerHTML = newValue[i].toString();
    }
});

onMounted(() => {
    for (let i = 0; i < odometerDigitsValues.value.length; i++) {
        const odometer = new Odometer({
            el: odometerDigitsRefs.value[i],
            value: "0",
        });
        odometer.render();

        setTimeout(() => {
            odometerDigitsRefs.value[i].innerHTML = odometerDigitsValues.value[i].toString();
        }, (odometerDigitsValues.value.length - i) * 300);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(odometerDigitsValues.value, (val, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'odometerDigitsValues-' + index,
        ref_for: true,
        ref_key: "odometerDigitsRefs",
        ref: odometerDigitsRefs
      }))
    }), 128)),
    (_ctx.isWidget)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"bonusomat-odometer__letter-odometer odometer-auto-theme\"><span class=\"bonusomat-odometer__odometer-inside\"><span class=\"odometer-digit\"><span class=\"odometer-digit-inner\"><span class=\"odometer-ribbon\"><span class=\"odometer-ribbon-inner\"><span class=\"bonusomat-odometer__letter\"><span class=\"odometer-value odometer-value--unit\">K</span></span></span></span></span></span></span></span><span class=\"bonusomat-odometer__letter-odometer odometer-auto-theme\"><span class=\"bonusomat-odometer__odometer-inside\"><span class=\"odometer-digit\"><span class=\"odometer-digit-inner\"><span class=\"odometer-ribbon\"><span class=\"odometer-ribbon-inner\"><span class=\"bonusomat-odometer__letter\"><span class=\"odometer-value odometer-value--unit\">č</span></span></span></span></span></span></span></span>", 2))
        ], 64))
      : (_ctx.unit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.unit), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})